import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/fr'; 

import { urls } from '../constants';

import SepaH from './sepaH';

import { Button } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';

// font awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPanorama } from '@fortawesome/free-solid-svg-icons';

const API_KEY = 'AIzaSyDM9oCumOpyRDeAdYyL7ebcRc_lqsWwpc4';
const CALENDAR_ID = 'petit.train.paimpol@gmail.com';

const Presentation = () => {    
    // store presentation in state
    const[presentation, setPresentation] = useState({});

    // to store events
    const [events, setEvents] = useState([]);

    // to get next events from google calendar events
    const [nextEvent, setNextEvent] = useState(null);
    const [nextEventLoaded, setNextEventLoaded] = useState(false);

    // to know if presentation is loaded
    const[presentationLoaded, setPresentationLoaded] = useState(false);

    useEffect(() => {
        findNextEvent();
    }, []);

    const findNextEvent = async () => {
        try {
            const startDate = moment().startOf('day');
            const endDate = moment(startDate).add(4, 'days');

            const response = await axios.get(
                `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events`,
                {
                    params: {
                        key: API_KEY,
                        timeMin: startDate.toISOString(),
                        timeMax: endDate.toISOString(),
                        singleEvents: true,
                    }
                }
            );

            const events = response.data.items;

            // filter events to remove private ones
            const publicsEvents = events.filter(event => {
                return event.visibility !== 'private';
            });
            
            // Get the current time
            const currentTime = new Date();
        
            // Find the next event
            const findNextEvent = () => {
                let nextEvent = null;
                let nextEventTime = Infinity;
        
                // Iterate over each event in the array
                publicsEvents.forEach(event => {
                    // Get the event's start time
                    const eventStartTime = new Date(event.start.dateTime);
        
                    // Check if the event's start time is after the current time
                    if (eventStartTime > currentTime && eventStartTime < nextEventTime) {
                        nextEvent = event;
                        nextEventTime = eventStartTime;
                    }
                });
        
                return nextEvent;
            };
    
            const nextEvent = findNextEvent();
            console.dir(nextEvent);
            setNextEvent(nextEvent);
            setNextEventLoaded(true);
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };

    // use effect hook to load presentation
    useEffect(() => {
        axios.get(urls.api_url+'texte_presentation?filter[orderby]=date&order=asc')
        .then((response) => {            
            if(response.status === 200) {
                setPresentation(response.data);
                setPresentationLoaded(true);
            }
        });
    }, []);

    return (
        <>
            {
                presentationLoaded ?
                    <div className="content">
                        <div className="content-text prochain-depart">
                                    <h3><strong>Prochain départ du Petit Train Paimpolais : </strong></h3>
                                    <h4><span className="titre">{moment(nextEvent.start.dateTime).format('dddd DD MMMM')} </span>: <Badge>{moment(nextEvent.start.dateTime).locale('fr').format('HH:mm')}</Badge> <span className="lieu">{nextEvent.summary}</span></h4>
                                    
                                    <p className="link-to-horaires">
                                        <Link to="/horaires"><Button variant="primary">Consulter les horaires suivants</Button></Link>
                                    </p>
                                </div>
                        <SepaH />
                        {
                            presentation.map((presentationItem, index) => (
                                <div className='content-text' dangerouslySetInnerHTML={{__html: presentationItem.contenu}}></div>
                            ))
                        }
                    </div>
                :
                    <div>Chargement</div>
            }
        </>
    );
};

export default Presentation;